import { eula_pt } from './eula_pt';

export const locale_pt = {
  ...eula_pt,
  Organization: 'Organização',
  AreYouSureRemoveMemberFromGroupParam: 'Tem certeza de que deseja remover {0} membro do grupo?',
  AreYouSureRemoveMembersFromGroupParam: 'Tem certeza de que deseja remover {0} membros do grupo?',
  RowsSelected: 'linha(s) selecionada(s)',
  AddToMembers: 'Adicionar aos membros',
  AssignRolesToGroup: 'Atribuir funções ao grupo',
  Confirm: 'Confirmar',
  Name: 'Nome',
  Reset: 'Redefinir',
  SaveChanges: 'Salvar alterações',
  GeneralProperties: 'Propriedades Gerais',
  AddMembersToGroup: 'Adicionar membros ao grupo',
  AddMembers: 'Adicionar membros',
  UnexpectedError: 'Erro inesperado',
  Confirmation: 'Confirmação',
  DeleteMember: 'Excluir membro',
  DeleteMembers: 'Excluir membros',
  Cancel: 'Cancelar',
  User: 'Usuário',
  Search: 'Pesquisar',
  RemoveMember: 'Remover membro',
  RemoveMembers: 'Remover membros',
  PleaseSelect: 'Por favor, selecione',
  Role: 'Função',
  Scope: 'Escopo',
  ScopeType: 'Tipo de Escopo',
  RolesAssigned: 'Funções atribuídas',
  SearchScope: 'Escopo de pesquisa',
  GroupParam: 'Grupo {0}',
  Home: 'Casa',
  Groups: 'Grupos',
  Members: 'Membros',
  Roles: 'Funções',
  AddGroup: 'Adicionar grupo',
  GroupInfo: 'Informações do grupo',
  GroupMembers: 'Membros do grupo',
  CheckGroupInfoAndUsersTabs: 'Por favor, verifique as informações do grupo e as guias de membros. algo está errado',
  AddNewGroup: 'Adicionar novo grupo',
  PleaseEnterName: 'Por favor, digite um nome',
  OrganizationDatabaseHasBeenCreated: 'O banco de dados da organização foi criado',
  OK: 'OK',
  SomethingWentWrong: 'Algo deu errado',
  OrganizationHasBeenBlocked: 'A organização foi bloqueada',
  OrganizationHasBeenUnblocked: 'A organização foi desbloqueada',
  Yes: 'Sim',
  No: 'Não',
  DisplayName: 'Nome de exibição',
  Email: 'E-mail',
  Address: 'Endereço',
  PleaseEnterAValidEmail: 'Por favor, insira um email válido',
  PleaseEnterAnAddress: 'Por favor, insira um endereço',
  DefaultLanguage: 'Idioma padrão',
  IsPartner: 'É Parceiro',
  IsBlocked: 'Está bloqueado',
  PartnerOrganization: 'Organização Parceira',
  Unblock: 'Desbloquear',
  Block: 'Bloquear',
  EnsureDB: 'Garantir DB',
  PleaseCheckTheInfoProvided: 'Por favor, verifique as informações fornecidas. algo está errado',
  AddMembersToOrganization: 'Adicionar membros à organização',
  PleaseSelectOrRemoveRow: 'Por favor, selecione ou remova a linha',
  Add: 'Adicionar',
  AreYouSureRemoveMemberParam: 'Tem certeza que deseja remover {0} membro da organização?',
  AreYouSureRemoveMembersParam: 'Tem certeza de que deseja remover {0} membros da organização?',
  DeleteUsers: 'Excluir usuários',
  InvitationSent: 'Convite enviado',
  InvitationNotSent: 'Convite não enviado',
  ResendInvitation: 'Reenviar convite',
  OrganizationMembers: 'Membros da Organização',
  Reload: 'Recarregar',
  TypeOrganizationNameToConfirm: 'Digite o nome da organização para confirmar',
  Type: 'Tipo',
  OrganizationParam: 'Organização {0}',
  Delete: 'Excluir',
  CanNotDeleteOrgs: 'Não é possível excluir organizações',
  CanNotdeleteOwnOrganization: 'Não é possível excluir a própria organização',
  AddOrganization: 'Adicionar Organização',
  CheckOrganizationInfoAndUserTabs: 'Por favor, verifique as informações da organização e guias de usuários. algo está errado',
  AddNewOrganization: 'Adicionar nova organização',
  CreationOrganizationAndItsDatabase: 'Criando organização e seu banco de dados. Isso pode levar vários minutos. Por favor, espere',
  PleaseSelectALanguage: 'Por favor, selecione um idioma',
  PleaseSelectOrInvite: 'Por favor, selecione ou convide',
  SelectOrInviteOrganizationMaster: 'Selecione ou convide o mestre da organização',
  OrganizationUsers: 'Usuários da organização',
  SelectRoles: 'Selecionar funções',
  AddUser: 'Adicionar usuário',
  PartnerRoles: 'Funções do parceiro',
  EditPartnerRole: 'Funções do parceiro',
  PleaseSelectASelector: 'Por favor, selecione um seletor',
  RoleName: 'Nome da função',
  RolesPermissions: 'Permissões de papéis',
  Allow: 'Permitir',
  Deny: 'Negar',
  Selector: 'Seletor',
  Edit: 'Editar',
  CreateRole: 'Criar função',
  NewPartnerRole: 'Nova função de parceiro',
  NewRole: 'Nova função',
  EditRole: 'Editar função',
  PleaseSelectAnOrganization: 'Por favor, selecione uma organização',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'Esta função está sendo atribuída por padrão aos criadores de alguns tipos de escopos. Tem certeza de que deseja excluí-lo?',
  RoleDelete: 'Tem certeza de que deseja excluir esta função?',
  DefaultRoleDelete: 'Tem certeza de que deseja excluir esta função padrão?',
  AddToGroups: 'Adicionar a grupos',
  AreYouSureWantRemoveUserFromGroup: 'Tem certeza de que deseja remover o usuário do grupo {0}?',
  AreYouSureWantRemoveUserFromGroups: 'Tem certeza de que deseja remover o usuário de {0} grupos?',
  DeleteGroup: 'Excluir grupo',
  DeleteGroups: 'Excluir grupos',
  RemoveMembership: 'Remover associação',
  RemoveMemberships: 'Remover associações',
  AssignRolesToUser: 'Atribuir funções ao usuário',
  UserParam: 'Usuário {0}',
  CanNotDeleteOwnUser: 'Não é possível excluir o próprio usuário',
  PasswordMustMatch: 'A senha deve corresponder',
  AddNewUser: 'Adicionar novo usuário',
  SetPassword: 'Definir senha',
  ConfirmPassword: 'Confirmar senha',
  BlankPasswordWarning:
    'Se você deixar o campo de senha em branco, o sistema assumirá que este usuário usará um provedor de autenticação externo para fazer login.',
  OrganizationsManagement: 'Gestão de Organizações',
  UsersManagement: 'Gerenciamento de usuários',
  RolesManagement: 'Gerenciamento de Funções',
  PartnerRolesManagement: 'Gerenciamento de funções de parceiro',
  GroupsManagement: 'Gestão de Grupos',
  BackHome: 'Voltar para casa',
  HomeError: 'Desculpe, a página que você visitou não existe.',
  NotFound: 'Não encontrado',
  ChangeOrganization: 'Mudar Organização',
  DeleteUser: 'Excluir usuário',
  ConfirmDeleteUser: 'Tem certeza que deseja excluir o usuário "{0}" com endereço de e-mail "{1}"?',
  UserDeleted: 'Usuário "{0}" com endereço de e-mail "{1}" foi excluído com sucesso.',

  DisplayingFilteredItems: 'Exibindo itens filtrados por uma notificação.',
  ShowAllItems: 'Mostrar todos os itens',
  NotificationTimestampMessageMinutes: 'há {0} minutos',
  NotificationTimestampMessageHours: 'há {0} horas',
  Yesterday: 'Ontem',
  Read: 'Lido',
  Unread: 'Não lido',
  Action: 'Ação',
  AffectedElement: 'Elemento afetado',
  LinkTo: 'Link para',
  State: 'Estado',
  Date: 'Data',
  Notifications: 'Notificações',
  NotificationStatus: 'Status da notificação',
  InApp: 'No aplicativo',
  NotificationsSettings: 'Configurações de notificações',
  DeleteAfter: 'Excluir após',
  OneWeek: 'Uma semana',
  OneMonth: 'Um mês',
  OneYear: 'Um ano',
  ThreeMonths: 'Três meses',
  SixMonths: 'Seis meses',
  DeleteAllNotifications: 'Excluir todas',
  SurveySynchedRingNotificationDescription: 'O survey "{A}" foi sincronizado no furo de sondagem "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'O survey "{A}" foi sincronizado no Ring "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'O survey "{A}" foi sincronizado na quarentena.',
  OrganizationCreationFinishedNotificationTitle: 'Organização criada',
  OrganizationExpirationWarningNotificationTitle: 'A organização está prestes a expirar',
  OrganizationCreationErrorNotificationTitle: 'Erro ao criar organização',
  OrganizationIsAvailableNotificationTitle: 'Organização disponível',
  LicenseNeedsApprovalNotificationTitle: 'A licença precisa de aprovação',
  LicenseWasRenewedNotificationTitle: 'A licença foi renovada',
  RingCreatedNotificationTitle: 'Ring criado',
  SurveySynchedNotificationTitle: 'Survey sincronizado',
  ProjectDeletedNotificationTitle: 'Projeto excluído',
  ProjectEditedNotificationTitle: 'Projeto editado',
  DrillholeDeletedNotificationTitle: 'Furo de sondagem excluído',
  RingDeletedNotificationTitle: 'Ring excluído',
  DrillholeMovedNotificationTitle: 'Furo de sondagem movido',
  RingMovedNotificationTitle: 'Ring movido',
  DrillholeEditedNotificationTitle: 'Furo de sondagem atualizado',
  RingEditedNotificationTitle: 'Ring atualizado',
  SurveySignoffNotificationTitle: 'Solicitação de aprovação de survey',
  DrillholeCreatedNotificationTitle: 'Furo de sondagem criado',
  BulkDrillholesUpdateNotificationTitle: 'Furos de sondagem editados',
  BulkDrillholesMovedNotificationTitle: 'Furos de sondagem movidos',
  BulkRingsMovedNotificationTitle: 'Rings movidos',
  BulkDrillholesDeletedNotificationTitle: 'Furos de sondagem excluídos',
  BulkRingsDeletedNotificationTitle: 'Rings excluídos',
  BulkProjectsDeletedNotificationTitle: 'Projetos excluídos',
  BulkRingsCreatedNotificationTitle: 'Rings criados',
  BulkDrillholesCreatedNotificationTitle: 'Furos de sondagem criados',
  SurveyDeletedNotificationTitle: 'Survey excluído',
  SurveyDeletedNotificationDescription: 'O survey "{A}" foi excluído.',

  OrganizationCreationFinishedNotificationDescription: 'A organização {A} foi criada com {X} membros.',
  OrganizationExpirationWarningNotificationDescription: 'A organização {A} está prestes a expirar.',
  OrganizationCreationErrorNotificationDescription: 'Ocorreu um erro ao criar a organização {A}.',
  OrganizationIsAvailableNotificationDescription: 'A organização {A} está disponível agora.',
  LicenseNeedsApprovalNotificationDescription: 'Uma licença com o código da ferramenta {A} precisa de aprovação.',
  LicenseWasRenewedNotificationDescription: 'Uma licença com o código da ferramenta {A} foi renovada.',
  SurveySynchedNotificationDescription: 'O survey "{A}" foi sincronizado no furo de sondagem "{B}".',
  ProjectDeletedNotificationDescription: 'O projeto "{A}" foi excluído.',
  ProjectEditedNotificationDescription: 'O projeto "{A}" foi editado.',
  DrillholeDeletedNotificationDescription: 'O furo de sondagem "{A}" foi excluído.',
  RingDeletedNotificationDescription: 'O Ring "{A}" foi excluído.',
  DrillholeMovedNotificationDescription: 'O furo de sondagem "{B}" foi movido para "{A}".',
  RingMovedNotificationDescription: 'O Ring "{B}" foi movido para o projeto "{A}".',
  DrillholeEditedNotificationDescription: 'O furo de sondagem "{A}" foi atualizado',
  RingEditedNotificationDescription: 'O Ring "{A}" foi atualizado',
  SurveySignoffNotificationDescription: 'Foi solicitada uma aprovação para o survey "{A}".',
  DrillholeCreatedNotificationDescription: 'Um furo de sondagem com o nome "{B}" foi criado em "{A}".',
  RingCreatedNotificationDescription: 'Um Ring com o nome "{B}" foi criado no projeto "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} furos de sondagem foram editados em "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} furos de sondagem foram movidos para "{B}".',
  BulkRingsMovedNotificationDescription: '{X} Rings foram movidos para o projeto "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} furos de sondagem foram excluídos',
  BulkRingsDeletedNotificationDescription: '{X} Rings foram excluídos',
  BulkProjectsDeletedNotificationDescription: '{X} projetos foram excluídos.',
  BulkRingsCreatedNotificationDescription: '{X} Rings foram criados.',
  BulkDrillholesCreatedNotificationDescription: '{X} furos de sondagem foram criados em "{B}".',
  ForgotPasswordNotificationTitle: 'E-mail de redefinição de senha enviado',
  OrganizationInvitationNotificationTitle: 'Convite para organização recebido',
  LicenseQRSharedNotificationTitle: 'Licença compartilhada com você',
  ToolUsageReportNotificationTitle: 'Relatório de uso de ferramentas pronto',
  OrganizationCreationFinishedNotificationTitleError: 'Erro ao criar organização',
  OrganizationIsAvailableNotificationTitleError: 'Erro ao disponibilizar organização',
  LicenseWasRenewedNotificationTitleError: 'Erro ao renovar licença',
  RingCreatedNotificationTitleError: 'Erro ao criar Ring',
  SurveySynchedNotificationTitleError: 'Erro ao sincronizar survey',
  ProjectDeletedNotificationTitleError: 'Erro ao excluir projeto',
  ProjectEditedNotificationTitleError: 'Erro ao editar projeto',
  DrillholeDeletedNotificationTitleError: 'Erro ao excluir furo de sondagem',
  RingDeletedNotificationTitleError: 'Erro ao excluir Ring',
  DrillholeMovedNotificationTitleError: 'Erro ao mover furo de sondagem',
  RingMovedNotificationTitleError: 'Erro ao mover Ring',
  DrillholeEditedNotificationTitleError: 'Erro ao atualizar furo de sondagem',
  RingEditedNotificationTitleError: 'Erro ao atualizar Ring',
  DrillholeCreatedNotificationTitleError: 'Erro ao criar furo de sondagem',
  BulkDrillholesUpdateNotificationTitleError: 'Erro ao editar furos de sondagem',
  BulkDrillholesMovedNotificationTitleError: 'Erro ao mover furos de sondagem',
  BulkRingsMovedNotificationTitleError: 'Erro ao mover Rings',
  BulkDrillholesDeletedNotificationTitleError: 'Erro ao excluir furos de sondagem',
  BulkRingsDeletedNotificationTitleError: 'Erro ao excluir Rings',
  BulkProjectsDeletedNotificationTitleError: 'Erro ao excluir projetos',
  BulkRingsCreatedNotificationTitleError: 'Erro ao criar Rings',
  BulkDrillholesCreatedNotificationTitleError: 'Erro ao criar furos de sondagem',
  SurveyDeletedNotificationTitleError: 'Erro ao excluir survey',
  ForgotPasswordNotificationTitleError: 'Erro ao enviar e-mail de redefinição de senha',
  OrganizationInvitationNotificationTitleError: 'Erro ao enviar convite para organização',
  LicenseQRSharedNotificationTitleError: 'Erro ao compartilhar licença',
  ToolUsageReportNotificationTitleError: 'Erro ao gerar relatório de uso da ferramenta',

  SurveyDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o survey "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Ocorreu um erro ao criar a organização {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Ocorreu um erro ao disponibilizar a organização {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Ocorreu um erro ao renovar a licença com o código da ferramenta {A}.',
  SurveySynchedNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" no furo de sondagem "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o projeto "{A}".',
  ProjectEditedNotificationDescriptionError: 'Ocorreu um erro ao editar o projeto "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o furo de sondagem "{A}".',
  RingDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o Ring "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Ocorreu um erro ao mover o furo de sondagem "{B}" para "{A}".',
  RingMovedNotificationDescriptionError: 'Ocorreu um erro ao mover o Ring "{B}" para o projeto "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Ocorreu um erro ao atualizar o furo de sondagem "{A}".',
  RingEditedNotificationDescriptionError: 'Ocorreu um erro ao atualizar o Ring "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar o furo de sondagem "{A}" em "{B}".',
  RingCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar o Ring "{A}" no projeto "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Ocorreu um erro ao editar {X} furos de sondagem em "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Ocorreu um erro ao mover {X} furos de sondagem para "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Ocorreu um erro ao mover {X} Rings para o projeto "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir {X} furos de sondagem.',
  BulkRingsDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir {X} Rings.',
  BulkProjectsDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir {X} projetos.',
  BulkRingsCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar {X} Rings.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar {X} furos de sondagem em "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Ocorreu um erro ao enviar o e-mail de redefinição de senha.',
  OrganizationInvitationNotificationDescriptionError: 'Ocorreu um erro com um convite para a organização. Verifique.',
  LicenseQRSharedNotificationDescriptionError: 'Ocorreu um erro ao compartilhar a licença.',
  ToolUsageReportNotificationDescriptionError: 'Ocorreu um erro ao gerar ou enviar o relatório de uso da ferramenta.',
  SurveySynchedRingNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" no furo de sondagem "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" no Ring "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" na quarentena.',
  IsRead: 'Lido',
  RelatedEntityName: 'Nome da entidade relacionada',
  RelatedEntityType: 'Tipo da entidade relacionada',
  RedirectEntityName: 'Nome da entidade de redirecionamento',
  RedirectEntityType: 'Tipo da entidade de redirecionamento',
  Count: 'Quantidade',
  Enable: 'Habilitar',
  SendNotificationsViaEmail: 'Enviar notificações por e-mail',
  Title: 'Título',
  Description: 'Descrição',
  TypeHeader: 'Tipo',

  ForgotPasswordNotificationDescription: 'Um e-mail contendo um link para redefinição de senha foi enviado.',
  OrganizationInvitationNotificationDescription: 'Você foi convidado para participar de uma organização. Verifique seu e-mail para mais detalhes.',
  LicenseQRSharedNotificationDescription: 'Uma licença foi compartilhada com você. Verifique seu e-mail para mais detalhes.',
  ToolUsageReportNotificationDescription: 'O relatório de uso de ferramentas foi gerado com sucesso e enviado para o seu e-mail.',

  Now: 'Agora',
  EmptyNotificationsTextTitle: 'Você está em dia!',
  EmptyNotificationsTextSubtitle: 'Você não tem novas notificações',
  LastWeek: 'Semana passada',
  Today: 'Hoje',
  ThisWeek: 'Esta semana',
  ThisMonth: 'Este mês',
  MarkAsRead: 'Marcar como lida',
  MarkAsReadAll: 'Marcar como lidas',

  //Permissions
  //Admin
  CreatePartnerOrganization: 'Criar organização parceira',
  DeletePartnerOrganization: 'Excluir organização parceira',
  ManageDefaultRoles: 'Gerenciar funções padrão',
  ManagePermissions: 'Gerenciar permissões',
  //Partners
  BlockOrganization: 'Organização do bloco',
  CreateOrganization: 'Criar Organização',
  DeleteOrganization: 'Excluir Organização',
  ManageLicenses: 'Gerenciar Licenças',
  ManageRoleAssignment: 'Gerenciar atribuições de função',
  //Organization
  CreateProject: 'Criar projeto',
  ManageGroups: 'Gerenciar Grupos',
  ManageOrganizationInfo: 'Gerenciar informações da organização',
  ManageOrganizationRoleAssignments: 'Gerenciar atribuições de funções da organização',
  ManageQuarantine: 'Gerenciar quarentena',
  ManageRecycleBin: 'Gerenciar RecycleBin',
  ManageRoles: 'Gerenciar funções',
  ManageUnitSystem: 'Gerenciar Sistema de Unidade',
  ManageUnitSystems: 'Gerenciar Sistemas de Unidade',
  ManageUsers: 'Gerenciar usuários',
  //Project
  CreateDrillhole: 'Criar Furo',
  DeleteProject: 'Excluir projeto',
  ManageProjectInfo: 'Gerenciar informações do projeto',
  ManageProjectRoleAssignments: 'Gerenciar ProjectRoleAssignments',
  ViewProjectData: ' Visualizar dados do projeto',
  //Ring
  CreateRing: 'Criar ring',
  DeleteRing: 'Excluir ring',
  ManageRingInfo: 'Gerenciar informações do ring',
  ManageRingRoleAssignments: 'Gerenciar atribuições de funções de ring',
  ShareRing: 'Compartilhar ring',
  ViewRingData: 'Ver dados do ring',
  CreateRingDrillhole: 'Criar furos de ring',
  //Drillhole
  DeleteDrillhole: 'Excluir furo',
  ManageDrillholeInfo: 'Gerenciar informações do furo de sondagem',
  ManageDrillholeRoleAssignments: 'Gerenciar atribuições de função de perfuração',
  ViewDrillholeData: 'Visualizar dados do furo de sondagem',
  ManageSurveys: 'Gerenciar pesquisas',
  SynchronizeSurveys: 'Gerenciar pesquisas',
  WelcomeBackParam: 'Bem-vindo de volta, {0}!',
  Change: 'Alterar',
  Unauthorized: 'Não autorizado',
  YouDontHaveAccessToSite: 'Você não tem acesso ao centro de parceiros',
  LoginOutInSecondsParam: 'Login em {0} segundos',
  CreationJobForOrganizationEnqueued: 'O trabalho de criação para esta organização foi enfileirado',
  RestartCreation: 'Reiniciar Criação',
  AssignRoleWarning:
    'Você está atribuindo funções: {0} a {1} no nível da organização. As funções serão aplicadas a todas as entidades selecionadas e {1} terá permissão para todas as informações contidas em {2}',
  UpdateExpiredRoleWarning:
    'Os papéis: {0} foram previamente atribuídos a {1}, mas expiraram. A data selecionada substituirá a data de expiração anterior e os papéis voltarão a ficar ativos.',
  DoYouWantToContinue: 'Deseja continuar?',
  MemberAlreadyInOrganizarion: 'O usuário já é membro da organização {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'Você selecionou este usuário mais de uma vez',
  ClearFilter: 'Limpar filtro',
  ElementsSussessfulyDeleted: 'Elementos sucessivamente excluídos',
  DownloadErrorsFile: 'Baixar arquivo de erros',
  Errors: 'Erros',
  DownloadWarningsFile: 'Baixar arquivo de avisos',
  Warnings: 'Avisos',
  FailDeletion: 'Falha na exclusão',
  OrderBy: 'Ordenar por',
  rowsSelected: 'linha(s) selecionada(s)',
  AddNew: 'Adicionar novo',
  DeleteAll: ' Excluir tudo',
  ImportCSV: 'Importar CSV',
  BulkUploadItems: 'Carregar itens em massa',
  Licenses: 'Licenças',
  ToolCode: 'Código da ferramenta',
  DeviceType: 'Tipo de dispositivo',
  FromDate: 'Desde a data',
  UntilDate: 'Até a data',
  CreatedOn: 'Até a data',
  CreatedBy: 'Criado por',
  Unlimited: 'Ilimitado',
  Coefficients: 'Coeficientes',
  Continuous: 'Contínuo',
  Multishot: 'Multishot',
  Zupt: 'Zup',
  Offline: 'Off-line',
  Flash: 'Flash',
  Notes: 'Notas',
  AddLicense: 'Adicionar licença',
  AddNewLicense: 'Adicionar nova licença',
  PleaseEnterToolCode: 'Por favor, insira o código da ferramenta',
  LicenseCopied: 'Licença copiada para a área de transferência',
  License: 'Licença',
  Copy: 'Copiar',
  ErrorLoadingLicense: 'Erro ao carregar licença',
  ShowLicense: 'Exibir licença',
  LicenseAlreadyExists:
    'Você está tentando criar uma nova licença para {0} #{1} de {6} até {7}, mas já existe uma licença criada para {0} #{1} de {2} até {3} por {4} em {5}. Deseja continuar e criar uma nova licença mesmo assim?',
  UnlimitedLicenseAlreadyExists:
    'Já existe uma licença ilimitada criada para {0} #{1} por {2} em {3}. Deseja continuar e criar uma nova licença mesmo assim?',
  Continue: 'Continuar',
  PeriodOfValidity: 'Período de Validade',
  CopyLicense: 'Copiar Licença',
  CopyAll: 'Copiar tudo',
  PleaseSelectDates: 'Selecione Datas',
  Project: 'Projeto',
  Customer: 'Cliente',
  ExportCSV: 'Exportar CSV',
  Reports: 'Relatórios',
  Export: 'Exportar',
  Separator: 'Relatórios',
  Tab: 'Aba',
  Semicolon: 'Ponto e vírgula',
  Comma: 'Vírgula',
  AreYouSureYouWantToDelete: 'Tem certeza de que deseja excluir os itens selecionados?',
  AreYouSureYouWantToDeleteSelected: 'Tem certeza de que deseja excluir os itens selecionados?',
  ThereWasAProblemCreatingLicense: 'Ocorreu um problema ao criar a licença. Por favor, entre em contato com um administrador.',
  ExpirationDate: 'Data de Expiração',
  UpdateRoleAttributes: 'Editar atributos de função',
  Update: 'Atualizar',
  AllowedDevices: 'Dispositivos permitidos',
  RoleExpirationDate: 'Data de vencimento da função',
  PleaseEnterExpirationDate: 'Por favor, insira uma data de validade',
  MaximumLicenseDueDate: 'Data máxima de vencimento da licença',
  PleaseEnterMaxDueDate: 'Por favor, insira a data máxima de vencimento da licença',
  MaxLicensesPeriodInDays: 'Período Máximo de Licença em Dias',
  PleaseEnterMaxLicensesPeriodInDays: 'Por favor, insira o período máximo de licença em dias',
  MaxNumberOfLicensesPerMonth: 'Número máximo de licenças por mês',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Por favor, insira o número máximo de licenças por mês',
  DeleteElements: 'Excluir elementos',
  DeleteItems: 'Excluir elementos',
  DeleteSelected: 'Excluir selecionado',
  DeviceTypeNotAllowed: 'Você não tem permissão para criar uma licença para esse dispositivo',
  MaximumLicenseDueDateReached: 'Você não tem permissão para criar licenças com data de vencimento após {0}',
  MaxLicensesPeriodInDaysReached: 'As licenças que você criar devem ser válidas por um período máximo de {0} dias.',
  MaxNumberOfLicensesPerMonthReached:
    'Você atingiu o número máximo de licenças criadas por mês. Aguarde até o próximo mês para criar uma nova licença.',
  ApprovalPending: 'Aprovação Pendente',
  InitializingOrganization: 'Inicializando a organização. Os usuários estarão disponíveis em breve',
  InvalidToolCode: 'O código da ferramenta tem de ter exatamente quatro dígitos',
  EditRoles: 'Editar funções',
  EditRolesMessage: 'Editar funções do usuário',
  RolesWillBeRemoved: 'As seguintes funções serão removidas: {0}. ',
  RolesWillBeAssigned: 'As seguintes funções serão atribuídas: {0}. ',
  ThisUserIsOrganizationMaster: 'Este usuário já foi selecionado como mestre da organização',
  RemainingLicensesMessage: 'Você tem um total de {0} licenças restantes para este mês',
  MaxLicenseNumberReached: 'Você atingiu o número máximo de licenças para este mês',
  EULATitle: 'Contrato de licença de usuário final (EULA)',
  OrganizationIsExporting: 'A organização está a exportar, aguarde...',
  ErrorExportingOrganization: 'Ocorreu um erro ao exportar a organização {0}. Por favor, tente novamente',
  ExportingOrganizationSuccess: 'O processo de exportação foi iniciado e, quando concluído, enviaremos o link de download para seu e-mail.',
  CanNotDeleteOrganizationWhileExporting:
    'A organização {0} está a ser exportada e não pode ser eliminada neste momento. Aguarde e tente novamente daqui a pouco.',
  CheckingIfOrganizationExists: 'Verificando se a organização existe...',
  RestoreOrganizationConfirmDialog:
    'Esta organização já existe, pretende continuar? Todos os dados desta organização serão sobrescritos com os dados de cópia de segurança.',
  ExportingProcessStarted: 'O processo de exportação foi iniciado, a transferência começará em breve',
  ExportOrganization: 'Exportar Organização',
  ImportOrganization: 'Importar Organização',
  UploadOrganizationBackup: 'Carregar cópia de segurança da organização',
  AddOrganizationFile: 'Clique ou arraste o ficheiro de cópia de segurança da organização para esta área para carregar',
  ImportingOrganizationStarted: 'O processo de importação foi iniciado',
  ImportingOrganizationSuccess: 'O processo de importação foi iniciado; quando ele for concluído, enviaremos uma notificação para seu e-mail',
  ErrorImportingOrganization: 'Ocorreu um erro ao importar a organização. Por favor, tente novamente',
  Importing: 'Importando...',
  LastImportDate: 'Esta organização foi restaurada pela última vez de um backup em  ',
  ShowOrganizationLicenses: 'Licenças da organização:',
  ShowAll: 'Mostrar tudo',

  DefaultRolesTableError: 'Ocorreu um erro ao carregar as funções padrão. Por favor, tente novamente.',
  GroupsTableError: 'Ocorreu um erro ao carregar os grupos. Por favor, tente novamente',
  ErrorSavingGroupProperties: 'Ocorreu um erro ao salvar as propriedades do grupo. Por favor, tente novamente',
  ErrorAddingGroupMembers: 'Ocorreu um erro ao adicionar os membros ao grupo. Por favor, tente novamente.',
  GroupRolesTableError: 'Ocorreu um erro ao carregar as funções do grupo. Por favor, tente novamente.',
  LicensesTableError: 'Ocorreu um erro ao carregar as licenças. Por favor, tente novamente.',
  OrganizationsTableError: 'Ocorreu um erro ao carregar as organizações. Por favor, tente novamente.',
  ErrorAddingOrganizationMembers: 'Ocorreu um erro ao adicionar os novos membros à organização. Tente novamente.',
  ErrorRemovingOrganizationMembers: 'Ocorreu um erro ao remover os novos integrantes da organização. Tente novamente.',
  RoleListTableError: 'Ocorreu um erro ao carregar as funções. Por favor, tente novamente.',
  UsersTableError: 'Ocorreu um erro ao carregar a lista de usuários. Por favor, tente novamente.',
  ErrorAddingGroup: 'Ocorreu um erro ao adicionar o grupo. Por favor, tente novamente.',
  ErrorRemovingGroup: 'Ocorreu um erro ao remover o grupo. Por favor, tente novamente.',
  UserRolesTableError: 'Ocorreu um erro ao carregar as funções do usuário. Por favor, tente novamente.',
  InvitationNotSentErrorMessage: 'Ocorreu um erro ao enviar o convite. Tente novamente.',
  ErrorDeletingUser: 'Ocorreu um erro ao excluir o usuário. Tente novamente.',
  PartnerRolesTableError: 'Ocorreu um erro ao carregar as funções de parceiro. Por favor, tente novamente.',
  PaginationTotal: 'Mostrando {0} itens de {1}',
  SelectOrInviteUser: 'Selecionar ou convidar usuário',
  SelectOrInviteUsers: 'Selecionar ou convidar usuários',
  CheckDB: 'Verificar banco de dados',
  ManageGlobalLicenses: 'Gerenciar licenças globais',
  ManageRoleAssignments: 'Gerenciar atribuições de função',
  ShareDrillhole: 'Compartilhar furos de sondagem',
  SignOffSurveys: 'Assinar pesquisas',
  ViewSurveyData: 'Exibir dados de pesquisa',
  Organizations: 'Organizações',
  SelectSelector: 'Selecionar seletor',
  SelectOrganization: 'Selecionar organização',
  GroupMembership: 'Associação do grupo',
  SelectEntity: 'Selecionar entidade',
  Users: 'Usuários',
  AddUserToGroups: 'Adicionar usuário a grupos',
  SelectLanguage: 'Selecionar idioma',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  Restore: 'Restaurar',
  RestoreBackupConfirmMessage:
    'Pretende restaurar esta cópia de segurança? Quaisquer alterações efectuadas na organização após a criação da cópia de segurança serão perdidas',
  RestoreBackupSuccess: 'O processo de restauração do backup foi iniciado. Quando terminar, enviaremos um e-mail para você.',
  Backups: 'Cópias de segurança',
  OrganisationBackups: 'Backups organizacionais',
  OrganizationName: 'Nome da organização',
  Statistics: 'Estatísticas',
  Last24Hours: 'Últimas 24 horas',
  Last3Days: 'Últimos 3 dias',
  Last7Days: 'Últimos 7 dias',
  Last28Days: 'Últimos 28 dias',
  FilterByDate: 'Filtrar por data',
  Projects: 'Projetos',
  Surveys: 'Pesquisas',
  ProjectsNumber: 'Número de projetos',
  UsersNumber: 'Número de usuários',
  SurveysNumber: 'Número de pesquisas',
  CreationDate: 'Data de criação',
  LastUpdate: 'Última atualização',
  CustomDateRange: 'Intervalo de datas personalizado',
  OrganizationIsLocked: 'Essa organização está bloqueada no momento porque está sendo usada em outro processo. Aguarde e tente novamente em breve.',
  SelectGroups: 'Selecionar grupos',
  ErrorUpdatingRole: 'Ocorreu um erro ao atualizar as permissões da função. Por favor, tente novamente.',

  WorkingHours: 'Horas de trabalho',
  PleaseEnterWorkingHours: 'Por favor, insira as horas de trabalho',

  Country: 'País',
  PleaseSelectCountry: 'Por favor, selecione um país',

  // Country names
  Afghanistan: 'Afeganistão',
  Albania: 'Albânia',
  Algeria: 'Argélia',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antígua e Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Arménia',
  Australia: 'Austrália',
  Austria: 'Áustria',
  Azerbaijan: 'Azerbaijão',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrein',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Bielorrússia',
  Belgium: 'Bélgica',
  Belize: 'Belize',
  Benin: 'Benim',
  Bhutan: 'Butão',
  Bolivia: 'Bolívia',
  'Bosnia and Herzegovina': 'Bósnia e Herzegovina',
  Botswana: 'Botswana',
  Brazil: 'Brasil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgária',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Camboja',
  Cameroon: 'Camarões',
  Canada: 'Canadá',
  'Cape Verde': 'Cabo Verde',
  'Central African Republic': 'República Centro-Africana',
  Chad: 'Chade',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colômbia',
  Comoros: 'Comores',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Costa do Marfim',
  Croatia: 'Croácia',
  Cuba: 'Cuba',
  Cyprus: 'Chipre',
  'Czech Republic': 'República Checa',
  'Democratic Republic of the Congo': 'República Democrática do Congo',
  Denmark: 'Dinamarca',
  Djibouti: 'Djibouti',
  Dominica: 'Dominica',
  'Dominican Republic': 'República Dominicana',
  'East Timor': 'Timor-Leste',
  Ecuador: 'Equador',
  Egypt: 'Egito',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Guiné Equatorial',
  Eritrea: 'Eritreia',
  Estonia: 'Estónia',
  Ethiopia: 'Etiópia',
  Fiji: 'Fiji',
  Finland: 'Finlândia',
  France: 'França',
  Gabon: 'Gabão',
  Gambia: 'Gâmbia',
  Georgia: 'Geórgia',
  Germany: 'Alemanha',
  Ghana: 'Gana',
  Greece: 'Grécia',
  Grenada: 'Granada',
  Guatemala: 'Guatemala',
  Guinea: 'Guiné',
  'Guinea-Bissau': 'Guiné-Bissau',
  Guyana: 'Guiana',
  Haiti: 'Haiti',
  Honduras: 'Honduras',
  Hungary: 'Hungria',
  Iceland: 'Islândia',
  India: 'Índia',
  Indonesia: 'Indonésia',
  Iran: 'Irã',
  Iraq: 'Iraque',
  Ireland: 'Irlanda',
  Israel: 'Israel',
  Italy: 'Itália',
  Jamaica: 'Jamaica',
  Japan: 'Japão',
  Jordan: 'Jordânia',
  Kazakhstan: 'Cazaquistão',
  Kenya: 'Quénia',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Quirguistão',
  Laos: 'Laos',
  Latvia: 'Letónia',
  Lebanon: 'Líbano',
  Lesotho: 'Lesoto',
  Liberia: 'Libéria',
  Libya: 'Líbia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituânia',
  Luxembourg: 'Luxemburgo',
  Madagascar: 'Madagáscar',
  Malawi: 'Malawi',
  Malaysia: 'Malásia',
  Maldives: 'Maldivas',
  Mali: 'Mali',
  Malta: 'Malta',
  'Marshall Islands': 'Ilhas Marshall',
  Mauritania: 'Mauritânia',
  Mauritius: 'Maurícia',
  Mexico: 'México',
  Micronesia: 'Micronésia',
  Moldova: 'Moldávia',
  Monaco: 'Mónaco',
  Mongolia: 'Mongólia',
  Montenegro: 'Montenegro',
  Morocco: 'Marrocos',
  Mozambique: 'Moçambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namíbia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Países Baixos',
  'New Zealand': 'Nova Zelândia',
  Nicaragua: 'Nicarágua',
  Niger: 'Níger',
  Nigeria: 'Nigéria',
  'North Korea': 'Coreia do Norte',
  Norway: 'Noruega',
  Oman: 'Omã',
  Pakistan: 'Paquistão',
  Palau: 'Palau',
  Panama: 'Panamá',
  'Papua New Guinea': 'Papua-Nova Guiné',
  Paraguay: 'Paraguai',
  Peru: 'Peru',
  Philippines: 'Filipinas',
  Poland: 'Polónia',
  Portugal: 'Portugal',
  Qatar: 'Catar',
  'Republic of the Congo': 'República do Congo',
  'Republic of Macedonia': 'República da Macedónia',
  Romania: 'Roménia',
  Russia: 'Rússia',
  Rwanda: 'Ruanda',
  'Saint Kitts and Nevis': 'São Cristóvão e Nevis',
  'Saint Lucia': 'Santa Lúcia',
  'Saint Vincent and the Grenadines': 'São Vicente e Granadinas',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'São Tomé e Príncipe',
  'Saudi Arabia': 'Arábia Saudita',
  Senegal: 'Senegal',
  Serbia: 'Sérvia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Serra Leoa',
  Singapore: 'Singapura',
  Slovakia: 'Eslováquia',
  Slovenia: 'Eslovénia',
  'Solomon Islands': 'Ilhas Salomão',
  Somalia: 'Somália',
  'South Africa': 'África do Sul',
  'South Korea': 'Coreia do Sul',
  'South Sudan': 'Sudão do Sul',
  Spain: 'Espanha',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudão',
  Suriname: 'Suriname',
  Swaziland: 'Suazilândia',
  Sweden: 'Suécia',
  Switzerland: 'Suíça',
  Syria: 'Síria',
  Tajikistan: 'Tajiquistão',
  Tanzania: 'Tanzânia',
  Thailand: 'Tailândia',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad e Tobago',
  Tunisia: 'Tunísia',
  Turkey: 'Turquia',
  Turkmenistan: 'Turquemenistão',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ucrânia',
  'United Arab Emirates': 'Emirados Árabes Unidos',
  'United Kingdom': 'Reino Unido',
  'United States of America': 'Estados Unidos',
  Uruguay: 'Uruguai',
  Uzbekistan: 'Uzbequistão',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietname',
  Yemen: 'Iémen',
  Zambia: 'Zâmbia',
  Zimbabwe: 'Zimbabwe',

  TestOrganization: 'Organização de teste',
  RemovalDate: 'Data de remoção',
  IsTestOrganization: 'É uma organização de teste',
  TestingEndDate: 'Data de término do teste',
  TestOrgConfirmationMessage:
    'A entidade foi estabelecida como uma organização de teste e será automaticamente excluída na data selecionada. Tem certeza de que deseja continuar?',

  Show: 'Mostrar',
  Changed: 'Alterado',
  Unchanged: 'Inalterado',

  Charts: 'Gráficos',

  CreationChartLegend: 'Criação',
  UpdateChartLegend: 'Atualização',

  WelcomBackParam: 'Bem vindo de volta, {0}!',
  LicenseDetails: 'Detalhes da licença',
  Logout: 'Sair',

  CrashError: 'Ops! Algo deu muito errado',
  SeeAllLogs: 'Por favor, pressione F12 e envie todos os logs na guia Console ao relatar este incidente',
  ReturnHome: 'Voltar para casa',

  InvalidEmailWarning: 'Por favor selecione ou digite um e-mail válido',
  CheckOrganizationInfoAndUsersTabs: 'Por favor, verifique as informações da organização e guias de usuários. Algo está errado',

  UserHasNoOrganizationsWarning:
    'Este usuário não faz parte de nenhuma organização. Por favor, adicione-o a uma organização antes de atribuir funções.',

  UserHasNoOrganizationsGroupWarning:
    'Este usuário não faz parte de nenhuma organização. Por favor, adicione-o a uma organização antes de adicioná-lo a grupos.',

  'Customer Geologist': 'Geólogo do cliente',
  'Drillhole Manager': 'Gerente de furos',
  'Field Operator': 'Operador de campo',
  Geologist: 'Geólogo',
  'Global License Manager': 'Gerente de licenças globais',
  'License Manager': 'Gerente de licenças',
  'Organization Coordinator': 'Coordenador da organização',
  'Organization Master': 'Mestre da organização',
  'Partner Administrator': 'Administrador de parceiros',
  'Project Manager': 'Gerente de projeto',
  'Project Viewer': 'Visualizador de projetos',
  'Ring Manager': 'Gerente de rings',

  Partners: 'Parceiros',

  ActiveHours: 'Horas ativa',
  Active: 'Ativo',
  NotActive: 'Não ativo',
  Status: 'Status',
  Go: 'Ir',
  FilterByActiveDates: 'Filtrar por datas ativa',
  ActiveDays: 'Dias ativa',

  CanCreateUnlimitedLicense: 'Pode criar licenças que não expiram',
  CanCreateRecurrentLicenses: 'Pode criar licenças recorrentes',
  Recurrence: 'Recorrência',
  Activated: 'Ativado',
  Deactivated: 'Desativado',

  NeedsSignOff: 'Aprovação necessária',
  SelectedUserAlreadyHasTheSelectedRoles: 'O usuário selecionado já possui as funções: {0}.',
  SelectedGroupAlreadyHasTheSelectedRoles: 'O grupo selecionado já possui os papéis: {0}.',

  FilterMode: 'Modo de filtro',
  AllSelected: 'Todos selecionados',
  AnyOfTheSelected: 'Qualquer um dos selecionados',
  Download: 'Baixar',

  RoleAssignmentAttributes: 'Atributos de atribuição de função',
  LicenseManagerRoleAttributes: 'Atributos da função de gerente de licenças',

  'StructMaster User': 'Usuário do StructMaster',
  UseStructMaster: 'Usar StructMaster',

  StructmasterLicenses: 'Licenças StructMaster',
  NewStructmasterLicenseAssignment: 'Nova atribuição de licença StructMaster',
  EditStructmasterLicenseAssignment: 'Editar atribuição de licença StructMaster',
  SelectUser: 'Selecionar usuário',
  UserAlreadyHasStructMasterRole: 'Erro: Este usuário já possui o papel de StructMaster nesta organização',
  AddAnotherAssignment: 'Adicionar outra atribuição',
  AddRole: 'Adicionar papel',
  SelectRole: 'Selecionar papel',
  PleaseSelectRole: 'Por favor, selecione um papel',
  DuplicatedRolesWarning: 'Existem papéis duplicados na sua seleção. Certifique-se de que não há duplicatas.',
  RolesWillBeUpdated: 'Os seguintes papéis serão atualizados: {0}.',

  UserHasNoRoleWarning: 'O usuário deve ter pelo menos um papel na organização',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Aviso: O usuário "{0}" não pertence à organização "{1}", portanto, o usuário "{0}" será adicionado à organização antes de fazer a atribuição.',

  ManageCategories: 'Gerenciar categorias',
  ManageGeographicInformationSystems: 'Gerenciar sistemas de informação geográfica',

  Appearance: 'Aparência',
  DarkTheme: 'Tema escuro',
  LightTheme: 'Tema claro',
  UseSystemTheme: 'Usar tema do sistema',
  ScheduledMaintenanceText:
    'Manutenção programada: A plataforma na nuvem passará por manutenção programada em {0}. Os serviços podem ser interrompidos por uma duração estimada de {1} horas, a partir de {2}',
  MFAStatus: 'Status da autenticação multifator',
  Enabled: 'Ativado',
  Disabled: 'Desativado',
  EnableMFA: 'Ativar autenticação multifator',
  DisableMFA: 'Desativar autenticação multifator',

  UserLimit: 'Limite de usuários',
  PleaseEnterUserLimit: 'Por favor, insira o limite de usuários',
  CheckLicenseInfoAndUsersTabs: 'Por favor, verifique as abas de informações da licença e usuários. Algo está errado',
  LicenseInfo: 'Informações da licença',
  AddNewStructmasterLicense: 'Adicionar nova licença StructMaster',
  StructmasterLicense: 'Licença StructMaster',
  PleaseAddAtLeastOneUser: 'Por favor, adicione pelo menos um usuário',
  DuplicatedUserWarning: 'Este usuário já foi selecionado, por favor verifique',
  LicenseName: 'Nome da licença',
  UserAmountExceedLimit: 'O número de usuários inserido excede o limite selecionado, por favor verifique se os dados estão corretos.',

  UserAlreadyIsLicenseManagerError: 'Este usuário já pertence a um grupo de administradores de licenças. Por favor, selecione outro usuário',
  UserAlreadyIsStructmasterUserError: 'Este usuário já possui o papel de StructMaster. Por favor, selecione outro usuário',
  DefaultGroups: 'Grupos padrão',
  LicenseManagerGroups: 'Grupos de gerentes de licenças',
  UpdateAttributes: 'Atualizar atributos',
  ResetLicenseAccess: 'Redefinir acesso à licença',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Este usuário já pertence a um grupo de administradores de licenças, e há pelo menos um grupo de administradores de licenças na sua seleção. Por favor, revise isso',
  MoreThanOneLicenseManagerGroupSelectedError:
    'Há mais de um grupo de administradores de licenças na sua seleção, e um usuário só pode pertencer a um único grupo de administradores de licenças. Por favor, revise sua seleção.',
  Default: 'Padrão',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Já existe uma licença StructMaster com este nome, por favor selecione um nome diferente.',
  ThereIsAlreadyAGroupWithThisName: 'Já existe um grupo com este nome, por favor selecione um nome diferente',

  GroupLogsTableError: 'Ocorreu um erro ao carregar os registros de auditoria do grupo. Por favor, tente novamente.',
  DownloadQR: 'Baixar QR',
  FilterByUser: 'Filtrar por usuário',

  ActiveUser: 'Usuário ativo',

  AllowAllPermissionsForThisLevel: 'Permitir todas as permissões para este nível',
  AllowAllAvailablePermissions: 'Permitir todas as permissões disponíveis',
  AllowAllAvaliablePermissionsForThisSelector: 'Permitir todas as permissões disponíveis para este seletor',

  StructmasterLicensesOnlyOneActiveUserWarning: 'Aviso: Só pode haver um usuário ativo por vez para cada licença StructMaster.',

  SelectUsersToShare: 'Selecionar usuários para compartilhar',
  SelectOrEnterEmailAddress: 'Selecionar usuário ou inserir endereço de e-mail',
  Share: 'Compartilhar',
  NoUsersSelectedError: 'Por favor, selecione pelo menos um usuário ou insira um endereço de e-mail',
  AddEmail: 'Adicionar e-mail',

  OrganizationUserLimitWarningCreation: 'Aviso: Você só pode adicionar no máximo {0} usuários a uma organização',
  OrganizationUserLimitWarningParam:
    'Aviso: Você só pode adicionar no máximo {0} usuários a esta organização e já possui um total de {1}, então só poderá adicionar mais {2}.',
  OrganizationReachedUserLimit: 'Erro: Esta organização já atingiu o número máximo de usuários permitidos. Por favor, selecione outra organização.',
  NewGroupUserCountErrorParam:
    'Erro: Esta organização permite no máximo {0} usuários, com {1} atualmente, e você está tentando adicionar {2} novos. Verifique se as informações estão corretas.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Os seguintes usuários serão adicionados à organização:',

  UnsignedStructmasterLicenses: 'Licenças StructMaster não assinadas',
  SaveAndSignOff: 'Salvar e assinar',
  SignOffStructmasterLicenseWarningTitle: 'Assinar licença StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Você está prestes a aprovar a criação de uma nova licença StructMaster. Os usuários serão adicionados à organização selecionada, caso ainda não façam parte dela, e o papel será atribuído. Deseja continuar?',

  ShowOnlyUnsignedLicenses: 'Mostrar apenas licenças pendentes de aprovação',
  ClearFilters: 'Limpar filtros',
  ApproveLicenses: 'Aprovar licenças',
  Save: 'Salvar',

  SoftwareVersion: 'Versão do software',
  AnErrorOcurred: 'Ocorreu um erro:',
  DeleteUnsignedLicense: 'Excluir licença não aprovada',
  DeleteUnsignedLicenseWarning: 'Você tem certeza de que deseja excluir a licença não aprovada "{0}"?',
  SignOff: 'Aprovação',
  Refuse: 'Recusar',
  ErrorCreatingLicense: 'Erro ao criar a licença',
  ErrorUpdatingLicense: 'Erro ao atualizar a licença',

  DuplicatedRoleNameErrorCreate:
    'Erro ao criar o papel: Já existe um papel com o nome "{0}" na organização "{1}". Por favor, insira um nome diferente.',
  DuplicatedRoleNameErrorUpdate:
    'Erro ao atualizar o papel: Já existe um papel com o nome "{0}" na organização "{1}". Por favor, insira um nome diferente.',
  DuplicatedDefaultRoleNameErrorUpdate: 'Erro ao atualizar o papel: Já existe um papel padrão com o nome "{0}". Por favor, insira um nome diferente.',
  PleaseEnterAValidSearchTerm: 'Por favor, insira um termo de pesquisa válido',
  TextFieldLimitError: 'O campo "{0}" não deve exceder {1} caracteres',
  InvalidToolcode: 'Por favor, insira um código de ferramenta válido',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Os grupos do gerenciador de licenças devem ter pelo menos uma função',
  PleaseSelectAtLeastOneDeviceType: 'Por favor selecione pelo menos um tipo de dispositivo',
  Language: 'Linguagem',
  NoData: 'Sem dados',
  PleaseEnterCoreDiameter: 'Por favor, insira o diâmetro do núcleo',
  CoreDiameter: 'Diâmetro do núcleo',
  SmartCoreLicenseAlreadyExists:
    'Você está tentando criar uma nova licença para {0} #{1} com diâmetro de ferramenta "{8}" de {6} a {7}, mas já existe uma licença criada para {0} #{1} com diâmetro de ferramenta "{8}" de {2} a {3} por {4} em {5}. Deseja continuar e criar uma nova licença mesmo assim?',
  UnlimitedSmartCoreLicenseAlreadyExists:
    'Já existe uma licença ilimitada criada para {0} #{1} com diâmetro de ferramenta "{8}" por {2} em {3}. Deseja continuar e criar uma nova licença mesmo assim?',
  ToolDiameter: 'Diâmetro da ferramenta',
  ToolcodeTooLarge: 'O código da ferramenta é demasiado grande. O código deve ser um número entre 1 e 65535',
  'License Reviewer': 'Revisor de licenças',
  'Client Manager': 'Gerente de clientes',
  MeasurementCount: 'Pesquisas',
  ToolSerialNumber: 'Número de série da ferramenta',
  ExportCsvReport: 'Exportar relatório CSV',
  ToolType: 'Tipo de ferramenta',
  FirstUsedOn: 'Data do primeiro uso',
  LastUsedOn: 'Data do último uso',
  ErrorGeneratingReport: 'Ocorreu um erro ao gerar o relatório. Por favor, tente novamente.',
  ToolUsageReport: 'Relatório de uso de ferramentas',
  ExportToolUsageReport: 'Exportar relatório de uso de ferramentas',
  ToolUsageReportInProcess: 'O relatório de uso da ferramenta está sendo gerado. Ele será enviado para o seu e-mail quando estiver concluído.',
  ProjectName: 'Nome do Projeto',
  Group: 'Grupo',
  SelectOrInviteWarning: 'Por favor selecione ou convide',
  ManagePartnerOrganization: 'Gerenciar organização parceira',
  ManageAdminOrganization: 'Gerenciar organização administradora',
};
